import React from 'react';
import PostEditor from '../components/PostEditor';
import { PostFormData } from '../types/post';
import toast from 'react-hot-toast';
import InstagramConnect from '../components/InstagramConnect';
import { useQuery } from 'react-query';
import { getInstagramAccount } from '../lib/instagram';

export default function PostScheduler() {
  const { data: account } = useQuery('instagramAccount', getInstagramAccount);
  const [showConnectPopup, setShowConnectPopup] = React.useState(false);

  const handleSubmit = async (data: PostFormData) => {
    if (!account?.connected) {
      setShowConnectPopup(true);
      return;
    }

    // Here we would normally save to the database and schedule the post
    console.log('Post scheduled:', data);
    toast.success('Post scheduled successfully!');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-4xl font-bold text-gray-900">Post Scheduler</h1>
        <InstagramConnect />
      </div>
      
      <div className="bg-white rounded-xl shadow-sm p-8 border border-gray-100">
        <PostEditor onSubmit={handleSubmit} />
      </div>

      {/* Instagram Connect Modal */}
      {showConnectPopup && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 relative">
            <button
              onClick={() => setShowConnectPopup(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div className="text-center mb-6">
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900">Connect Instagram to publish</h3>
              <p className="text-sm text-gray-500 mt-2">Your post has been saved as a draft</p>
            </div>
            <div className="flex justify-center">
              <InstagramConnect />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}